/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_By_WeekInputs */

const vi_my_grower_report_by_week = /** @type {(inputs: My_Grower_Report_By_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từng tuần`)
};

/**

* @param {My_Grower_Report_By_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_by_week = /** @type {((inputs?: My_Grower_Report_By_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_By_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_by_week(inputs)
});